import { css } from '@emotion/react'

export const icon: Style = css({
  margin: 0,
  padding: 0,
  lineHeight: 1,
})
